import Box from "@/components/Box";
import Center from "@/tpo/Center";
import Group from "@/tpo/Group";

import GreenTick from "./icons/greenTick";
import RedCross from "./icons/redCross";

export const LEVELS = {
  "Level 4": {
    label: "Level 4",
    fullName: "level 4 student practitioner",
    points: [
      {
        label: "Learning Hub access",
        type: "feature"
      },
      {
        label: "Purchase tests via Find a Practitioner",
        type: "feature"
      },
      {
        label: "No direct test purchases",
        type: "missingFeature"
      }
    ]
  },
  "Level 5": {
    label: "Level 5",
    fullName: "level 5 student practitioner",
    points: [
      {
        label: "Learning Hub access",
        type: "feature"
      },
      {
        label: "Access to most popular tests for personal use only*",
        type: "feature"
      },
      {
        label: "Purchase tests at trade price",
        type: "feature"
      },
      {
        label: "Access to support calls for test interpretation",
        type: "feature"
      },
      {
        label: "No access to purchase for others",
        type: "missingFeature"
      }
    ],
    conditions: ["*You must have attended a relevant Lunch and Learn part 1"]
  },
  "Level 6": {
    label: "Level 6",
    fullName: "level 6 student practitioner",
    points: [
      {
        label: "Learning Hub access",
        type: "feature"
      },
      {
        label: "Access to all tests for use in supervised training clinics",
        type: "feature"
      },
      {
        label: "Purchase tests at trade price for up to 5 clients (limited to 5 per test)",
        type: "feature"
      },
      {
        label: "You may not order tests for friends, family or anyone outside the clinic setting",
        type: "missingFeature"
      },
      {
        label: "Access to support calls for test interpretation",
        type: "feature"
      },
      {
        label: "Access to Lunch and Learn part 1 and 2",
        type: "feature"
      },
      {
        label: "You may order tests for clients only if your institution permits it*",
        type: "feature"
      }
    ],
    conditions: [
      "*Please refer to your training provider’s ordering policy.",
      "Student access does not grant practitioner status. Ordering on behalf of clients is only allowed in supervised training clinics and only when permitted by your provider."
    ]
  },
  "Full access": {
    label: "Full practitioner",
    fullName: "full practitioner"
  }
};

export function LevelFeatures({ level, fontSize, lineHeight }) {
  const levelFeatures = LEVELS[level];

  if (!levelFeatures || !levelFeatures.points) return;

  return (
    <>
      <Box as="ul" display="flex" flexDirection="column" gap={24}>
        {levelFeatures.points.map(p => (
          <Group
            key={p.label}
            gap={8}
            alignItems="top"
            as="li"
            fontSize={fontSize}
            lineHeight={lineHeight}
          >
            {p.type === "feature" ? (
              <GreenTick />
            ) : (
              <Center width={24} height={24}>
                <RedCross />
              </Center>
            )}
            {p.label}
          </Group>
        ))}
      </Box>
      <Box>
        {levelFeatures.conditions?.map(c => (
          <Group key={c} gap={8} alignItems="center" fontSize={14} lineHeight={lineHeight}>
            {c}
          </Group>
        ))}
      </Box>
    </>
  );
}
